import { COUNTRIES, LOCALIZED_COUNTRIES } from './countries'
import { BREAKPOINT_VALUES as BREAKPOINTS, SEMANTIC_BREAKPOINT_MAP, SWIPER_BREAKPOINTS } from './breakpoints'

const IMAGE_CUT = {
  POSTER: 'poster',
  BACKDROP: 'backdrop',
  BANNER: 'banner',
  SQUARE: 'square',
  ICON: 'icon',
  PANORAMA: 'panorama',
  MEDIUM_V: 'mediumv',
} as const

const CARD_TYPE = {
  TOP_BANNER: 'TopBannerCard',
  EVENT: 'EventCard',
  HORIZONTAL: 'HorizontalCard',
  VERTICAL: 'VerticalCard',
  CHANNEL_HORIZONTAL: 'ChannelHorizontalCard',
  TEAM: 'TeamCard',
  BANNER: 'BannerCard',
  MATCH_POSTER: 'MatchPosterCard'
} as const

const WSC_CARD_TYPE = {
  ROW_CIRCLE: 'row-circle',
  ROW_RECTANGLE: 'row-rectangle',
  ROW_RECTANGLE_HORIZONTAL: 'row-rectangle-horizontal',
  ROW_RECTANGLE_ANIMATED: 'row-rectangle-animated',
  GRID_2_COLUMNS: 'grid-2-columns',
  GRID_3_COLUMNS: 'grid-3-columns',
  GRID_2_COLUMNS_HORIZONTAL: 'grid-2-columns-horizontal',
  GRID_3_COLUMNS_HORIZONTAL: 'grid-3-columns-horizontal',
} as const

const DEVICE_TYPES = {
  XSMALL: 'isXs',
  MOBILE: 'isMobile',
  TABLET: 'isTablet',
  DESKTOP: 'isDesktop',
  LARGE_DESKTOP: 'isLargeDesktop',
  EXTRA_LARGE_DESKTOP: 'isExtraLargeDesktop',
}

const PLAYLIST_TYPES = {
  TOP_BANNER: 'TopBannerPlaylist',
  HORIZONTAL: 'HorizontalPlaylist',
  EVENTS: 'EventsPlaylist',
  WSC_STORIES: 'WSCStoriesPlaylist',
  WSC_MOMENTS: 'WSCMomentsPlaylist',
} as const

const AUDIO_OPTIONS_FLAGS = {
  en: '🇬🇧',
  es: '🇪🇸',
  pt: '🇵🇹',
  nat: '🔊',
} as const

// Order gateway types managed outside our checkout: their plan cards show
// "Provider: {label}" instead of renewal/price and route the user to the
// provider instead of /manage-subscription. 'bango' is the direct Entel Chile
// deal (PRO-13..15); 'digital-virgo-entel' is the older Entel-via-aggregator
// integration.
const EXTERNAL_PROVIDERS = ['toolbox', 'digital-virgo-entel', 'joinnus', 'inapp', 'googlePlay', 'roku', 'bango']

const EXTERNAL_PROVIDERS_LABELED = [
  {
    key: 'toolbox',
    label: 'Toolbox'
  },
  {
    key: 'digital-virgo-entel',
    label: 'Digital Virgo'
  },
  {
    key: 'bango',
    label: 'Entel'
  },
  {
    key: 'joinnus',
    label: 'Joinnus'
  },
  {
    key: 'inapp',
    label: 'App Store'
  },
  {
    key: 'googlePlay',
    label: 'Google Play'
  },
  {
    key: 'roku',
    label: 'Roku'
  },
]

const ORDER_STATUS_LABEL: any = {
  0: 'Paused',
  1: 'Active',
  2: 'Canceled',
  4: 'Deactivated',
  8: 'Past Due',
  16: 'Trialing',
  32: 'Changed',
  64: 'Pending',
} as const

const SITE_LANGUAGES = [
  {
    label: 'English',
    value: 'en'
  },
  {
    label: 'Spanish',
    value: 'es'
  },
  {
    label: 'Portuguese',
    value: 'pt'
  }
]

const CANCELABLE_ORDER_STATUSES: any = [0, 1, 8, 16, 64]

const ZERO_DECIMAL_GATEWAYS = ['roku']

const PERIOD_TAG_TEXT = {
  month: 'Monthly',
  year: 'Yearly',
  week: 'Weekly',
  day: 'PPV',
}

const NAVBAR_THEMES = {
  default: { backgroundColor: 'transparent' },
  joinnus: { backgroundColor: '#18233e' }
}

// Re-exported for existing client imports; BFF/SSR code should import
// `@/constants/roles` directly to keep this barrel out of its module graph.
export { USER_ROLES, type UserRole } from './roles'

export {
  BREAKPOINTS,
  SEMANTIC_BREAKPOINT_MAP,
  SWIPER_BREAKPOINTS,
  DEVICE_TYPES,
  IMAGE_CUT,
  PLAYLIST_TYPES,
  AUDIO_OPTIONS_FLAGS,
  EXTERNAL_PROVIDERS,
  EXTERNAL_PROVIDERS_LABELED,
  ORDER_STATUS_LABEL,
  SITE_LANGUAGES,
  COUNTRIES,
  LOCALIZED_COUNTRIES,
  CANCELABLE_ORDER_STATUSES,
  CARD_TYPE,
  WSC_CARD_TYPE,
  ZERO_DECIMAL_GATEWAYS,
  PERIOD_TAG_TEXT,
  NAVBAR_THEMES,
}
